define('controllers/authentication',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/session',
    'services/user',
    'services/api',
    // Contoller super class
    'src/controller/controller',
    // Models
    'models/member/profile',
    // Views | Layout
    'views/app/login/layout-login',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Session,
    User,
    API,
    // controller
    Controller,
    // Models
    MProfile,
    // Views | Layout
    VLayoutLogin
) {

    var AuthenticationCtrl = Controller.extend({
        routes: {
            "*else": "indexRoute", // default from parent Controller
            "login(/)": "loginRoute",
            "login/:token": "checkLogin",
            "logout(/)": "logoutRoute",
        },

        initialize: function(prefix, opt) {
            opt = opt || {};

            this.view = {};
        },

        getLayoutInstance: function() {
            return new VLayoutLogin();
        },

        ////////////
        // Routes //
        ////////////
        indexRoute: function() {
            this.redirect(this.url.root + "login");
            //var logoutUrl = window.env.OLD_ORIGIN + 'public/login.php';
            //window.location.href = logoutUrl;
        },

        loginRoute: function() {
            if (Session.isAuthenticated()) {
                this.listenTo(User, 'sync', this.onUserSync);
                User.fetch();
            } else {
                this.getLayout();
            }
        },

        checkLogin: function(token) {
            var userId = null;
            var oauth2_key = null;

            //Check for a valid token format
            if (token.indexOf(":") > 0 && token.substring(token.indexOf(":") + 1).length > 0) {
               userId = token.split(':')[0];
               oauth2_key = token.split(':')[1];
              //userId = Mongo.ObjectId() default length 24 and oauth2_key defined in API as 32 char
               if (userId.length !== 24 || oauth2_key.length !== 32) {
                  //Invalid token, so redirection to the login page
                  window.Rollbar.error("Authentication.js\n" + "Invalid Token format: " + this.token);
                  this.redirect(this.url.root + "login");
                  // var logoutUrl = window.env.OLD_ORIGIN + 'public/login.php';
                  // window.location.href = logoutUrl;
                  return;
               }
             }

            Session.useToken(token);
            this.token = token;
            //Redirect to activation form if user is fetch properly with a valid activation Link
            /*(i.e. The latest generated Oauth2 in DB. The Key field is the second part of the activationLink and the second part of the token)
                    "oauth2" : [
                {
                    "key" : "806bde12770a4c07bf95085fdbffa1a8",
                    "permissions" : [
                        "full"
                    ],
                    "createDate" : ISODate("2017-12-20T15:53:48.000Z"),
                    "client" : "testclientid"
                }
            ]
            */
            if (Session.isAuthenticated()) {
                User.fetch({ async: false, force: true });
                userId = token.split(':')[0];
                var ActivationFormUrl = this.getActivationFormUrl(userId, token);
                //If the Url is empty; User password already defined, account already activated or maybe an invalid token!
                if (_.isEmpty(ActivationFormUrl)) {
                    this.onUserSync();
                } else {
                    Session.signOut({ noRedirect: true });
                    U.delayRedirect(ActivationFormUrl);
                }
            } else {
              this.indexRoute();
            }

        },

        logoutRoute: function() {
            Session.signOut();
        },

        getActivationFormUrl: function(userId, token) {
            var requestParam = Mustache.render("?userId={{{user_Id}}}&client_id={{{client_id}}}", {
                    user_Id: userId,
                    client_id: "testclientid",
                });
            var clientHash = "";

            Backbone.ajax(
                _.extend({
                    url: API.url("oauth2/oldtokenAnonymous") + requestParam,
                    method: "GET",
                    async: false,
                    context: this,
                }, {
                    success: function(response, textStatus, xhr) {
                        clientHash = response;
                    },
                    error: function(xhr, errmsg, err) {
                        clientHash = "error";
                        window.Rollbar.error("Authentication.js. getActivationFormUrl()\n" + "Token: " + this.token, err);
                    },
                })
            );

            var ActivationUrl;

            switch (clientHash) {
              case 'error':
                  ActivationUrl = '';
                  break;
              case 'no user found':
                  ActivationUrl = '';
                  window.Rollbar.error("Authentication.js. getActivationFormUrl(). No User Found with this token.\n" + "Token: " + this.token);
                  break;
              case 'user active':
                  ActivationUrl = '';
                  break;
              default:
                  ActivationUrl = Mustache.render("public/login.php?id={{{client_id}}}&hash={{{hash}}}", {
                           hash: clientHash,
                           client_id: userId,
                       });
                  ActivationUrl = window.env.OLD_ORIGIN + ActivationUrl;
                  break;
            }

            return ActivationUrl;
        },

        ////////////
        // events //
        ////////////

        onUserSync: function() {

          try {
                if (User.get("email") === '') return;

                //redirection from old web site after registration "try/register"
                if (User.needPaymentCenter()) {
                    this.redirect("/payment/forceModifyMethod/");
                    return;
                }
                //possible values -> false, expiredInAllGroup, expiredInAGroupButActiveInOne
                var expiredGroupStatus = User.isMemberOfExpiredGroup();

                switch (expiredGroupStatus) {
                    case "expiredInAGroupButActiveInOne":
                        document.cookie = "TCNeddExpirationToastr=true";
                        break;
                    case "expiredInAllGroup":
                        this.redirect("/payment/expired/");
                        return;
                    default:
                        //Normal login process
                        break;
                }

                if (User.getMainGroup() && User.getMainGroup().isSupervisor) {
                    this.redirect("supervisor");
                } else {
                    this.redirect("#/");
                }
              }
          catch (err) {
            window.Rollbar.error("Authentication.js\n" + "Token: " + this.token, err);
            this.indexRoute();
          }
        },

    });

    return AuthenticationCtrl;

});

